import { BaseApiResponseModel } from "api/model/BaseApiResponseModel";
import { categoryPaths } from "api/apiPaths";
import client from "api/client";
import { CategoryCreateRequestModel } from "./model/actions/create/CategoryCreateRequestModel";
import { CategoryUpdateRequestModel } from "./model/actions/update/CategoryUpdateRequestModel";
import { CategoriesRequestModel } from "./model/CategoriesRequestModel";
import { CategoriesResponseModel } from "./model/CategoriesResponseModel";
import { CategoryDetailResponseModel } from "./model/detail/CategoryDetailResponseModel";

export interface ICategoriesRepository {
  getList(
    params: CategoriesRequestModel
  ): Promise<BaseApiResponseModel<CategoriesResponseModel[]>>;
  getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<CategoryDetailResponseModel>>;
  createCategory(
    body: CategoryCreateRequestModel
  ): Promise<BaseApiResponseModel<CategoryDetailResponseModel>>;
  updateCategory(
    body: CategoryUpdateRequestModel
  ): Promise<BaseApiResponseModel<CategoryDetailResponseModel>>;
  deleteCategory(params: {
    code: string;
  }): Promise<BaseApiResponseModel<CategoryDetailResponseModel>>;
}

class CategoriesImpl implements ICategoriesRepository {
  async getList(
    params: CategoriesRequestModel
  ): Promise<BaseApiResponseModel<CategoriesResponseModel[]>> {
    return await client?.get(categoryPaths?.LIST, params);
  }

  async getDetail(params: {
    code: string;
  }): Promise<BaseApiResponseModel<CategoryDetailResponseModel>> {
    return await client?.get(categoryPaths?.DETAIL, params);
  }

  async createCategory(
    body: CategoryCreateRequestModel
  ): Promise<BaseApiResponseModel<CategoryDetailResponseModel>> {
    return await client?.post(categoryPaths?.CREATE, body);
  }

  async updateCategory(
    body: CategoryUpdateRequestModel
  ): Promise<BaseApiResponseModel<CategoryDetailResponseModel>> {
    return await client?.put(categoryPaths?.UPDATE, body);
  }

  async deleteCategory(params: {
    code: string;
  }): Promise<BaseApiResponseModel<CategoryDetailResponseModel>> {
    return await client?.delete(categoryPaths?.DELETE, params);
  }
}

export const defaultCategoryRepository = new CategoriesImpl();
